export default __webpack_public_path__ + "static/media/me.764a02d0.jpg";